const Theme = {
  body_background_color: '#f5f2eb',
  title_font: 'Lausanne',
  text_font: 'Lausanne',

  logo_image_url: 'lepivot.png',
  logo_height: 70,
  
  button_color: '#ffd63d',
  button_radius: 10,
}

export default Theme
// https://app.clickup.com/t/86dwnf9tw